import React, { useState } from "react";
import {
    DatePicker,
    TimePicker,
    LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { toast } from "react-toastify";
import axios from "axios";
import "./styles.scss";
import useThemeColors from "../vehicle/ThemeColors";
import { Loader } from "react-bootstrap-typeahead";

interface IPROPS {
    closeModal: any;
    refetch: any;
    requestedId: any;
    refetch2:any
    selectedTab:any
}

const RescheduleAppointment: React.FC<IPROPS> = ({
    closeModal,
    refetch,
    requestedId,
    refetch2,
    selectedTab
}) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [textArea, setTextArea] = useState("");
    const [loading, setLoading] = useState(false);

    


    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;
    const token = localStorage.getItem("customer-token");


          const shouldDisableDate = (date: Dayjs) => {
              const dayName = date.format("dddd"); // Get day name like "Sunday"
              return requestedId?.workshop_details?.holiday?.includes(dayName);
          };

               const [startHour, startMinute] = requestedId?.workshop_details?.startTime?.split(":") || [];
                  const [endHour, endMinute] = requestedId?.workshop_details?.endTime?.split(":") || [];
                  const now = dayjs(); // current time
                  const nowPlus2Hours = now.add(2, "hour");
          
                  const minWorkshopTime = dayjs().set("hour", +startHour).set("minute", +startMinute).set("second", 0);
                  const maxWorkshopTime = dayjs().set("hour", +endHour).set("minute", +endMinute).set("second", 0);
                  const selectedDateIsToday = selectedDate?.isSame(dayjs(), 'day');
          
          // If today, the minTime should be max(workshop start time, current time)
          // const minTime = selectedDateIsToday ? dayjs.max(minWorkshopTime, now) : minWorkshopTime;
       const minTime = selectedDateIsToday ? dayjs.max(minWorkshopTime, nowPlus2Hours) : minWorkshopTime;

          
          const maxTime = maxWorkshopTime;

          const shouldDisableTime = (value, view) => {
  if (!value || !view) return false;
  if (view === "hours") {
    const hour = value.hour();
    return hour < minTime.hour() || hour > maxTime.hour();
  }
  if (view === "minutes") {
    const hour = value.hour();
    const minute = value.minute();

    // If current hour is minHour, disable minutes before minMinute
    if (hour === minTime.hour()) {
      return minute < minTime.minute();
    }

    // If current hour is maxHour, disable minutes after maxMinute
    if (hour === maxTime.hour()) {
      return minute > maxTime.minute();
    }
  }

  return false;
};
console.log(requestedId,"requestedId")
console.log(selectedTab,"requestedId")

    const handleBookService = async (e) => {
        e.preventDefault();

        if (!selectedDate || !selectedTime) {
            alert("Please select both date and time.");
            return;
        }

        const datePart = dayjs(selectedDate).format("YYYY-MM-DD");
        const timePart = dayjs(selectedTime).format("HH:mm:ss");
        const preferredTime = dayjs(selectedTime).format("HH:mm:ss");

        const bookingServicePayload = {
            service_date: `${datePart} ${preferredTime}`,
            notes: textArea,
        };

        try {
              setLoading(true); // Start loading
            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/${selectedTab === "scheduled" ? requestedId?.request_id : requestedId?.id}/reschedule/`,
                bookingServicePayload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response?.data) {
                toast.success(response?.data?.message);
                // setIsCheckoutClicked(false)
                sessionStorage.clear();
                if (selectedTab === "booking") {
                    refetch2();
                }
                else {
                    refetch()
                }
                closeModal();

                // setCartItems([])
            }
        } catch (error) {
            toast.error("An error occured");
        }
        finally {
    setLoading(false); // End loading
}
    };
    const { selectedButtonBackgoundColors, selectedButtonColors } =
        useThemeColors();


  const convertTo12Hour = (time24:any) => {
  if (!time24) return '';
  const [hour, minute] = time24.split(":");
  const h = parseInt(hour, 10);
  const suffix = h >= 12 ? "PM" : "AM";
  const hour12 = ((h + 11) % 12 + 1);
  return `${hour12}:${minute} ${suffix}`;
};

    return (
        <div style={{ padding: "10px 20px" }} className="reschedule_service">
            <div style={{ display: "flex", justifyContent: "center" }}>
                <label style={{ fontSize: "18px", fontWeight: "600" }}>
                    Reschedule Appointment
                </label>
            </div>
            <div style={{ marginTop: "20px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <form
                        onSubmit={handleBookService}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                gap: "20px",
                                width: "100%",
                            }}
                        >
                            <DatePicker
                                // key={index}
                                label="Select Date"
                                value={selectedDate}
                                onChange={(newDate) => setSelectedDate(newDate)}
                                minDate={dayjs()}
                                shouldDisableDate={shouldDisableDate}
                            />
                            <TimePicker
                                label="Select Time"
                                value={selectedTime}
                                onChange={(newTime) => setSelectedTime(newTime)}
                                ampm={false}
                                minTime={minTime}
                                maxTime={maxTime}
                                shouldDisableTime={shouldDisableTime}

                            />
                        </div>
{/* 
                            <div style={{border: "1px solid #a8a4a4", display:" flex", justifyContent: "center", flexDirection: "column", padding: "5px 10px", width: "48%"}}>
                    <p style={{display: "flex", fontFamily: 'Atlassian Sans Ext', fontSize: "15px", gap: "10px", justifyContent: "space-between"}}>
                        <span>Holidays</span><span style={{whiteSpace: "nowrap"}}>Operating hours</span>
                        </p>
                        <p style={{display: "flex",justifyContent: "space-between"}}><span>{requestedId?.workshop_details?.holiday}</span><span><span>{requestedId?.workshop_details?.startTime}</span>-<span>{requestedId?.workshop_details?.endTime}</span></span></p>
                        </div> */}

                            <div className="holiday-operating" style={{border: "1px solid #a8a4a4", display:" flex", justifyContent: "center", flexDirection: "column", padding: "5px 10px", width: "100%"}}>
                    <p style={{display: "flex",  fontSize: "15px", gap: "10px", width: "100%", justifyContent: "space-between"}}>
                        <span style={{width: "100%"}}>Holidays</span><span style={{flex: "1"}}>{requestedId?.workshop_details?.holiday}</span>
                        </p>
                        <p style={{display: "flex", width: "100%",fontSize: "15px", justifyContent: "space-between"}}><span style={{width: "80%", whiteSpace:"nowrap"}}>Operating hours</span><span style={{whiteSpace: "nowrap"}}><span>{convertTo12Hour(requestedId?.workshop_details?.startTime)}</span>-<span>{convertTo12Hour(requestedId?.workshop_details?.endTime)}</span></span></p>
                        </div>



                        <div
                            style={{ display: "flex", flexDirection: "column" }}
                        >
                            <label style={{fontFamily:'karbon'}} >
                                Reason
                            </label>
                            <textarea
                                style={{
                                    padding: "10px",
                                    borderRadius: "10px",
                                }}
                                placeholder="Enter Reason Here"
                                onChange={(e) => setTextArea(e.target.value)}
                                value={textArea}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                            }}
                        >
                            <button
                                type="submit"
                                style={{
                                    width: "100%",
                                    padding: "10px 25px",
                                    borderRadius: "20px",
                                    // background: `${selectedButtonBackgoundColors}`,
                                    // color: `${selectedButtonColors}`,
                                    // border: `1px solid ${selectedBorderColor}`,
                                    whiteSpace: "nowrap",
                                    background: `${selectedButtonBackgoundColors}`,
                                    color: `${selectedButtonColors}`,
                                    border: "none",
                                    // padding: "10px 20px",
                                    // borderRadius: "20px",
                                    fontSize: "13px",
                                }}
                            >
                                {loading ? <>Rescheduling service...<Loader /></> : "Reschedule Service"}
                                
                            </button>
                        </div>
                    </form>
                </LocalizationProvider>
            </div>
        </div>
    );
};

export default RescheduleAppointment;
